var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("SeaExport.GeneratePrimaryDocNo"),
        visible: _vm.innerVisible,
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        width: "400px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        [
          !_vm.needServiceCode
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.PleasePrimaryOrderNumberRule")
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "" },
                      on: { change: _vm.handleRuleChange },
                      model: {
                        value: _vm.config.rule,
                        callback: function($$v) {
                          _vm.$set(_vm.config, "rule", $$v)
                        },
                        expression: "config.rule"
                      }
                    },
                    _vm._l(_vm.rules, function(rule) {
                      return _c("el-option", {
                        key: rule.uuid,
                        attrs: {
                          value: rule.name,
                          disabled:
                            !!rule.partnerId &&
                            rule.partnerId !== _vm.form.carrierId
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.needServiceCode
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.PleaseCodeOfTheNo") } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.config.identificationCode,
                        callback: function($$v) {
                          _vm.$set(_vm.config, "identificationCode", $$v)
                        },
                        expression: "config.identificationCode"
                      }
                    },
                    _vm._l(_vm.groupCodes, function(code) {
                      return _c("el-option", {
                        key: code.uuid,
                        attrs: { value: code.code }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v(_vm._s(_vm.$t("Message.Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }